import BeneficiaryBankForm from "./steps/SubForms/BeneficiaryBankForm";
import SenderBankForm from "./steps/SubForms/SenderBankForm";
import UnionPayPaymentDetailsForm from "./steps/SubForms/UnionPayPaymentDetailsForm";
import SenderUnionPayForm from "./steps/SubForms/SenderUnionPayForm";
import BankAccountPaymentDetails from "./steps/SubForms/BankAccountPaymentDetails";
import BusinessSenderForm from "./steps/SubForms/BusinessSenderForm";
import BeneficiaryBusinessForm from "./steps/SubForms/BeneficiaryBusinessForm";
import BusinessPaymentDetailsForm from "./steps/SubForms/BusinessPaymentDetailsForm";

export const formRegistry = {
  sender: {
    unionpay: SenderUnionPayForm,
    bank_account_individual: SenderBankForm,
    bank_account_business: BusinessSenderForm,
  },
  beneficiary: {
    unionpay: BeneficiaryBankForm,
    bank_account_individual: BeneficiaryBankForm,
    bank_account_business: BeneficiaryBusinessForm,
  },
  payment: {
    unionpay: UnionPayPaymentDetailsForm,
    bank_account_individual: BankAccountPaymentDetails,
    bank_account_business: BusinessPaymentDetailsForm,
  },
};
